import { FC, HTMLAttributes } from 'react';

export interface H2Props extends HTMLAttributes<HTMLHeadingElement> {}

export const H2: FC<H2Props> = ({ children, className }) => {
  return <h2 className={`h2 ${className}`}>{children}</h2>;
};
